import React, { useEffect } from 'react';
import { ViewMode } from 'packages/gannt/types';
import { ViewSwitcher } from './viewSwitcher';
import { Gantt } from 'packages/gannt';
import styles from './timeline.module.scss';
import { workspaceAPI } from 'pages/workspace/workspace.service';
import { KoButton, KoCard, KoDateFormatter, KoDescription, KoDP, KoForm, KoLoader, KoModal, KoNano, KoTag, KoText, KoTitle, KoToast } from 'packages';
import TimelineCurd from './curd';
// import { initTasks } from './helper';
export default function TimeLine() {
  const [view, setView] = React.useState(ViewMode.Day);
  const [tasks, setTasks] = React.useState();
  const [isChecked, setIsChecked] = React.useState(true);
  const [workspaces, setWorkspaces] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [currentWorkspace, setWorkspace] = React.useState(null);
  const [isOpenCurd, setOpenCurdModal] = React.useState(false);
  const [currentTask, setCurrentTask] = React.useState(null);
  const [deleteRequest, setDeleteModal] = React.useState(false);
  const [form] = KoForm.useForm();

  let columnWidth = 65;
  if (view === ViewMode.Year) {
    columnWidth = 350;
  } else if (view === ViewMode.Month) {
    columnWidth = 300;
  } else if (view === ViewMode.Week) {
    columnWidth = 250;
  }

  useEffect(() => {
    getWorkspace();
  }, []);

  const getWorkspace = () => {
    setLoading(true);
    workspaceAPI.getWorkspace().then(
      (data) => {
        setWorkspaces();
        setWorkspaces(data['workspaces']);
        setLoading(false);
        setWorkspace(data['workspaces'][0]);
        getTasks(data['workspaces'][0]?.workspaceId);
      },
      (err) => {
        setLoading(false);
      }
    );
  };

  const fixDates = tasks =>
    tasks.map(t => ({
      ...t,
      start: new Date(t.start),
      end: new Date(t.end)
    }));

  const getTasks = (workspaceId) => {
    setLoading(true);
    let query={
      sort:'createdAt:1'
    };
    workspaceAPI.getTasks(workspaceId, query).then(
      (data) => {
        setTasks(fixDates(data['timelines']));
        setOpenCurdModal(false);
        form.resetFields();
        setLoading(false);
      },
      (err) => {
        setLoading(false);
      }
    );
  };



  const handleTaskChange = (task) => {
    let newTasks = tasks.map((t) => (t.id === task.id ? task : t));
    setTasks(newTasks);
    handleSubmit(task);
  };

  const handleTaskDelete = (task) => {
    setTasks(tasks.filter((t) => t.id !== task.id));
    workspaceAPI.deleteTask(task.id, currentWorkspace?.workspaceId).then(
      (data) => {
        KoToast.success(`Task deleted successfully!`);
        getTasks(currentWorkspace?.workspaceId);
      },
      (err) => {
        setLoading(false);
      }
    );
  };

  const handleProgressChange = async(task) => {
    setTasks(tasks.map((t) => (t.id === task.id ? task : t)));
    handleSubmit(task);
    console.log("On progress change Id:", JSON.stringify(tasks));
  };

  const handleDblClick = (task) => {
    // setOpenCurdModal(true);
  };

  const handleClick = (task) => {
    console.log("On Click event Id:", task);
    setCurrentTask();
    setTimeout(() => {
      form.setFieldsValue(task);
      setCurrentTask(task);
      setOpenCurdModal(true);
    }, 10);
   
  };

  const handleSelect = (task, isSelected) => {
    console.log(
      task.name + " has " + (isSelected ? "selected" : "unselected")
    );
  };

  const handleExpanderClick = (task) => {
    setTasks(tasks.map((t) => (t.id === task.id ? task : t)));
    console.log("On expander click Id:" + task.id);
    handleSubmit(task);
  };

  const KeyColor = (bgColor) => {
    const isColorDark = (color) => {
      const hex = color.replace("#", "");
      const [r, g, b] = [parseInt(hex.substr(0, 2), 16), parseInt(hex.substr(2, 2), 16), parseInt(hex.substr(4, 2), 16)];
      const luminance = 0.299 * r + 0.587 * g + 0.114 * b;
      return luminance < 128;
    };

    return {
      backgroundColor: bgColor,
      color: isColorDark(bgColor) ? "#ffffff" : "#000000"
    };
  };


  const handleSubmit = (values) => {
    setLoading(true);
    if(!values['id']){
      values['id'] = KoNano('TSL');
    }
    workspaceAPI.createTask(values, currentWorkspace?.workspaceId, currentTask?.id).then(
      (data) => {
        setLoading(false);
        getTasks(currentWorkspace?.workspaceId);
      },
      (err) => {
        setLoading(false);
      }
    );
  };

  const onInit = (api) => {
    setTimeout(() => {
      form.setFieldsValue({});
      setCurrentTask();
      setOpenCurdModal(true);
    }, 10);
   
  };

  return (
    <div className={styles.wrapper}>
      {loading && <KoLoader />}
      <svg
        style={{
          position: "absolute",
          width: "100%",
          height: "100%",
          inset: 0
        }}
      >
        <defs>
          <pattern
            id="pattern-hero"
            width="20"
            height="20"
            x="0"
            y="0"
            patternUnits="userSpaceOnUse"
            patternTransform="translate(-11,-11)"
          >
            <circle cx="1" cy="1" r="1" fill="#ccc" />
          </pattern>
        </defs>

        <rect width="100%" height="100%" fill="url(#pattern-hero)" />
      </svg>

      <ViewSwitcher
        onViewModeChange={(viewMode) => setView(viewMode)}
        onViewListChange={setIsChecked}
        isChecked={isChecked}
        viewMode={view}
        setOpenCurdModal={(value) => {form.resetFields(); onInit(value);}}
      />
      <div className={styles.timelineProjects}>
        {workspaces.length > 0 &&
          workspaces.map((workspace) => (
            <KoCard onClick={() => {setWorkspace(workspace); getTasks(workspace?.workspaceId);}} className={`${styles.card} ${currentWorkspace?.workspaceId === workspace?.workspaceId ? styles.active : ''}`}
              key={workspace?.workspaceId}
              hoverable={true}>
              <div className={styles.aLink}>
                <div >
                  <div className={styles.titleKey}>
                    <div className={`${styles.headCircle}  ${workspace?.customerDetails?.companyName ?
                      workspace?.customerDetails?.companyName?.charAt(0).toLowerCase() : 'a'}`}>
                      {workspace?.customerDetails?.['logo'] ?
                        <KoDP shape={'default'} logo={workspace?.customerDetails?.['logo']} width={25} height={'auto'} />
                        :
                        <KoText className={`${styles.letter}`} text={workspace?.name?.charAt(0)} />
                      }
                    </div>
                    <div className={styles.titleValue}>
                      <div className={styles.verified}>
                        <KoText ellipsis={true} className={`${styles.text}`} text={workspace?.name} />
                      </div>
                      <KoTitle className={styles.title} ellipsis={true} text={workspace?.customerDetails?.companyName} level={4} />
                    </div>
                  </div>
                  <KoText style={workspace?.color && KeyColor(workspace?.color)} className={`${styles.key} ${!workspace?.color && styles[workspace?.key ? workspace?.key?.charAt(0).toLowerCase() : 'a']}`}
                    text={`${workspace?.key}`} />
                  <div className={styles.description} >
                    <KoDescription className={styles.span} text={` `} ellipsis={{
                      rows:2
                    }} />
                    <div className={styles.row}>
                      <KoText className={styles.date} text='Created on ' />
                      <KoDateFormatter format='DD-MMM-YYYY' data={workspace?.createdAt} className={styles.date} />
                    </div>
                  </div>
                 
                </div>
                <div className={styles.wostag}>
                  {workspace?.template?.type === 'Development' && <KoTag custom={true} iscount={false} color={`color-1`} value={workspace?.template?.type} />}
                  {workspace?.template?.type === 'Events' && <KoTag custom={true} iscount={false} color={`color-9`} value={workspace?.template?.type} />}
                  { workspace?.template?.type === 'Orders' && <KoTag custom={true} iscount={false} color={`color-2`} value={workspace?.template?.type} />}
                  {workspace?.template?.type === 'Sales' && <KoTag custom={true} iscount={false} color={`color-3`} value={workspace?.template?.type} />}
                  { workspace?.template?.type === 'Marketing' && <KoTag custom={true} iscount={false} color={`color-4`} value={workspace?.template?.type} />}
                  {workspace?.template?.type === 'Support' && <KoTag custom={true} iscount={false} color={`color-5`} value={workspace?.template?.type} />}
                  {workspace?.template?.type === 'HR' &&  <KoTag custom={true} iscount={false} color={`color-6`} value={workspace?.template?.type} />}
                  {workspace?.template?.type === 'Helpdesk' && <KoTag custom={true} iscount={false} color={`color-7`} value={workspace?.template?.type} />}
                  {workspace?.template?.type === 'Finance' && <KoTag custom={true} iscount={false} color={`color-8`} value={workspace?.template?.type} />}
                </div>
              </div>
            </KoCard>
          ))
        }
        
      </div>
      <div className={styles.gantt}>
        {tasks && tasks.length > 0 && <Gantt
          tasks={tasks}
          viewMode={view}
          onDateChange={handleTaskChange}
          // onDelete={handleTaskDelete}
          onProgressChange={handleProgressChange}
          onDoubleClick={handleDblClick}
          onClick={handleClick}
          onSelect={handleSelect}
          onExpanderClick={handleExpanderClick}
          listCellWidth={false}
          columnWidth={columnWidth}
        />}
      </div>
     
      <KoModal
        centered
        title={currentTask?.id ? 'Update Task' : 'Create Task'}
        open={isOpenCurd}
        handleOk={() => { setOpenCurdModal(false); }}
        onClose={() => { setOpenCurdModal(false); }}
        width={'50vw'}
        footer={[
          <KoButton key='cancel' label='Close' onClick={() => setOpenCurdModal(false)} />,
          <KoButton key='delete' label='Delete' type='primary' danger onClick={() => setDeleteModal(true)} />,
          <KoButton key='submit' label={currentTask?.id ? 'Update' : 'Create'} type='primary' onClick={() => form.submit()}/>
        ]}
      >
        <TimelineCurd workspace={currentWorkspace} form={form} tasks={tasks} initialValues={currentTask} handleSubmit={handleSubmit} />
      </KoModal>

      <KoModal
        title={`Delete Task`}
        centered
        open={deleteRequest}
        afterClose={() => { setCurrentTask(); }}
        handleOk={() => { setCurrentTask(); setDeleteModal(false); }}
        onClose={() => { setCurrentTask(); setDeleteModal(false); }}
        width={580}
        footer={[
          <KoButton key='cancel' label='Cancel' onClick={() => setDeleteModal(false)} />,
          <KoButton key='reset' color="danger" variant="solid" type='primary' label='Delete' onClick={() => handleTaskDelete(currentTask)} />
        ]}
      >
        {loading && <KoLoader circle={false} />}
        <div className={styles.suspend}>
          <KoTitle level={5} text={`Are you sure you want to delete this task?`} />
          <KoText text={`This action is irreversible, and it will result in the removal of their associated data.`} />
        </div>
      </KoModal>

    </div>
  );
}